import React from 'react'
import { BookOpen, Clock, Gauge, KeyRound, Link2 } from 'lucide-react'
import { fmtCount, relativeTime } from './model'

// Optional: where the partner API guide lives. Hidden when unset rather than
// pointing somewhere that may not exist.
const API_GUIDE_URL = import.meta.env.VITE_PARTNER_API_GUIDE_URL

export default function IntegrationStatus({ integration, channels, now }) {
  const rows = []

  if (channels?.api) {
    rows.push({
      icon: KeyRound, label: 'API key',
      value: <Status ok={integration.api_live}>{integration.api_live ? 'Live' : 'Not live'}</Status>,
    })
    const cap = integration.daily_cap
    rows.push({
      icon: Gauge, label: 'Daily lead cap',
      value: cap ? `${fmtCount(cap.used)} of ${fmtCount(cap.limit)} today` : 'No cap',
      hint: cap ? 'Counted per UTC day - it resets at midnight UTC.' : undefined,
    })
    rows.push({ icon: Clock, label: 'Last API lead', value: relativeTime(integration.last_api_lead_at, now) })
  }

  if (channels?.clicks) {
    rows.push({
      icon: Link2, label: 'Tracking link',
      value: (
        <Status ok={integration.tracking_link_active}>
          {integration.tracking_link_active ? 'Active' : integration.tracking_link ? 'Paused' : 'Not set up'}
        </Status>
      ),
    })
    rows.push({ icon: Clock, label: 'Last click', value: relativeTime(integration.last_click_at, now) })
  }

  return (
    <section className="pw-card" aria-label="Integration status" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <h2 className="pw-title" style={{ fontSize: 15, fontWeight: 700 }}>Integration status</h2>
      <dl style={{ margin: 0, display: 'flex', flexDirection: 'column' }}>
        {rows.map((row) => (
          <div key={row.label} title={row.hint} style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
            padding: '9px 0', borderBottom: '1px solid var(--border)',
          }}>
            <dt style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--text-secondary)' }}>
              <row.icon size={14} aria-hidden="true" style={{ color: 'var(--text-muted)' }} />
              {row.label}
            </dt>
            <dd className="pw-num" style={{ margin: 0, fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', textAlign: 'right' }}>
              {row.value}
            </dd>
          </div>
        ))}
      </dl>
      {channels?.api && API_GUIDE_URL && (
        <a className="btn btn-ghost btn-sm" href={API_GUIDE_URL} target="_blank" rel="noreferrer" style={{ alignSelf: 'flex-start' }}>
          <BookOpen size={13} aria-hidden="true" /> API integration guide
        </a>
      )}
    </section>
  )
}

function Status({ ok, children }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: ok ? 'var(--green)' : 'var(--text-muted)' }}>
      <span aria-hidden="true" style={{ width: 7, height: 7, borderRadius: 999, background: 'currentColor' }} />
      {children}
    </span>
  )
}
